import { clsx as cx } from "clsx";
import { usePlacesWidget } from "react-google-autocomplete";
import { FieldErrors } from "react-hook-form";

type TGooglePlacesAutocompleteProps = {
  onPlaceSelected: (place: any) => void;
  // Typing has to reach the form too - not every address is a Google suggestion,
  // and without this the box shows text the form never receives.
  onChange: (value: string) => void;
  onBlur?: () => void;
  errors: FieldErrors<any>;
  value: string | null | undefined;
};

const GooglePlacesAutocomplete = ({
  onPlaceSelected,
  onChange,
  onBlur,
  value,
  errors,
}: TGooglePlacesAutocompleteProps) => {
  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    onPlaceSelected: (place) => onPlaceSelected(place),
    options: {
      types: ["geocode", "establishment"],
      componentRestrictions: { country: "us" },
    },
    language: "en",
  });

  return (
    <input
      className={cx({ "p-invalid": errors.address })}
      placeholder="Address"
      tabIndex={10}
      value={value ?? ""}
      onChange={(event) => onChange(event.target.value)}
      onBlur={onBlur}
      style={{
        fontSize: "1rem",
        color: "#495057",
        background: "#ffffff",
        padding: "0.75rem 0.75rem",
        border: "1px solid #ced4da",
        transition:
          "background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s",
        appearance: "none",
        borderRadius: "6px",
      }}
      type="text"
      autoComplete="off"
      //@ts-ignore It's okay to use ts-ignore here
      ref={ref}
    />
  );
};

export default GooglePlacesAutocomplete;
